"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.checkReactVersion = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _react = _interopRequireDefault(require("react"));

var _Utils = require("./Utils");

// This file is included in every other javascript files when the library is packaged
var checkReactVersion = function checkReactVersion(reactModule) {
  if (!(0, _Utils.isProduction)() && console && console.warn && reactModule && reactModule.version) {
    var major = (0, _parseInt2.default)(reactModule.version.split(".")[0]);
    var minor = (0, _parseInt2.default)(reactModule.version.split(".")[1]);

    if (major === 16 && minor < 8 || major < 16) {
      console.warn("Warning: You are using React version ".concat(reactModule.version, ". ") + "As of March 2020, new releases of the UI Library will require at least React 16.8. " + "If you have questions or concerns, contact us on the #ui-coalition Slack channel.");
    }
  }
};

exports.checkReactVersion = checkReactVersion;
checkReactVersion(_react.default);